import Vue from 'vue'
import Router from 'vue-router'
import Main from '../view/Main.vue'
import Error from '../view/Error.vue'
import worflowRouter from '../router/worflowRouter'
import unitRouter from '../router/unitRouter'
import standardRouter from '../router/standardRouter'
import htmlRouter from '../router/htmlRouter'
import listviewRouter from '../router/listviewRouter'
import kscircleRouter from '../router/kscircleRouter'
import visitorRouter from '../router/visitorRouter'
import TaskRouter from '../router/taskRouter'
import helpRouter from '../router/helpRouter'
import batchRouter from '../router/batchRouter'
import discoveryRouter from '../router/discoveryRouter'
import carteenRouter from '../router/carteenRouter'
import systemInformation from '../router/systemInformation'
import annualleaveHistory from '../router/AnnualleaveHistory'
import BirthAnniversaryRouter from '../router/BirthAnniversaryRouter'
import amCheckRouter from '../router/amCheckRouter'
import financeRouter from '../router/financeRouter'
import ykbHomeRouter from '../router/ykbHomeRouter'
import ykbNewRouter from '../router/ykbNewRouter'
import eventInfoRouter from '../router/eventInfoRouter'
import pass from '../router/passRouter'
Vue.use(Router)
export default new Router({
  mode: 'history',
  //base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main
    },
    worflowRouter,
    unitRouter,
    standardRouter,
    htmlRouter,
    listviewRouter,
    kscircleRouter,
    BirthAnniversaryRouter,
    visitorRouter,
    financeRouter,
    ykbHomeRouter,
    ykbNewRouter,
    eventInfoRouter,
    pass,
    {
      path: "*",
      name: 'Error',
      component: Error
    },
    TaskRouter,
    helpRouter,
    batchRouter,
    discoveryRouter,
    carteenRouter,
    systemInformation,
    annualleaveHistory,
    amCheckRouter
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js